:host {
  --dropdown-width: 240px;
}

gz-dropdown {
  display: flex;
  width: var(--dropdown-width);
  --form-field-input-width: var(--dropdown-width);
}
